export default __webpack_public_path__ + "static/media/businessdeal.f7334749.svg";